import { render, staticRenderFns } from "./CustomerComplaint2.vue?vue&type=template&id=4db25e56"
import script from "./CustomerComplaint2.vue?vue&type=script&lang=js"
export * from "./CustomerComplaint2.vue?vue&type=script&lang=js"
import style0 from "./CustomerComplaint2.vue?vue&type=style&index=0&id=4db25e56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports